import React, { useState, useEffect } from "react";
import { getCateringOrders } from "../../../Servicefile/ordermanagementservice.jsx";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Filter: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3" />
        </svg>
    ),
    Check: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
            <polyline points="20 6 9 17 4 12" />
        </svg>
    ),
    X: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
    ),
    Calendar: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
            <line x1="16" y1="2" x2="16" y2="6" />
            <line x1="8" y1="2" x2="8" y2="6" />
            <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
    ),
    Location: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    ),
    Vendor: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
            <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
    ),
    Money: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2" />
            <line x1="8" y1="21" x2="16" y2="21" />
            <line x1="12" y1="17" x2="12" y2="21" />
            <path d="M8 7h8M8 11h6M8 15h4" />
        </svg>
    ),
    Total: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9-4-18-3 9H2" />
        </svg>
    ),
    Accepted: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#155724" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
        </svg>
    ),
    Paid: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#004085" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M8 12h8" />
            <path d="M12 8v8" />
        </svg>
    ),
    Pending: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#856404" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
    ),
    Eye: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    ),
    User: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
        </svg>
    )
};

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        minHeight: '500px'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '12px',
        padding: '0 0 16px 0',
        borderBottom: '2px solid #e9ecef'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filterGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flexWrap: 'wrap'
    },
    searchInput: {
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        height: '38px',
        minWidth: '220px'
    },
    refreshBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 14px',
        background: 'rgb(230 109 51)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        height: '38px',
        transition: 'all 0.2s ease'
    },
    statsContainer: {
        display: 'flex',
        gap: '12px',
        flexWrap: 'wrap',
        padding: '16px 0',
        borderBottom: '1px solid #edf2f7',
        marginBottom: '16px'
    },
    statCard: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 16px',
        background: 'white',
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        boxShadow: '0 1px 4px rgba(0,0,0,0.04)',
        transition: 'all 0.2s ease',
        flex: '1 1 180px'
    },
    statIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    statIconTotal: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    statIconAccepted: {
        background: '#c6f6d5',
        color: '#155724'
    },
    statIconPaid: {
        background: '#bee3f8',
        color: '#004085'
    },
    statIconPending: {
        background: '#fefcbf',
        color: '#856404'
    },
    statContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    statValue: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#2d3748',
        lineHeight: '1.2'
    },
    statLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#718096',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '950px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 14px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        verticalAlign: 'middle'
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '600',
        letterSpacing: '0.3px'
    },
    badgeAssigned: {
        background: '#c6f6d5',
        color: '#155724'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    enquiryId: {
        fontWeight: '600',
        color: 'rgb(230 109 51)'
    },
    userIdText: {
        fontFamily: 'monospace',
        fontSize: '12px',
        color: '#4a5568',
        fontWeight: '600'
    },
    viewBtn: {
        background: '#e2e8f0',
        color: '#2d3748',
        border: 'none',
        borderRadius: '6px',
        padding: '5px 10px',
        fontSize: '12px',
        fontWeight: '500',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        transition: 'all 0.2s ease'
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        padding: '20px'
    },
    modalCard: {
        background: 'white',
        borderRadius: '12px',
        width: '100%',
        maxWidth: '650px',
        maxHeight: '90vh',
        overflow: 'auto',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        padding: '24px'
    },
    modalHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #edf2f7',
        paddingBottom: '14px',
        marginBottom: '16px'
    },
    modalTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#2d3748',
        margin: 0
    },
    closeBtn: {
        background: 'none',
        border: 'none',
        fontSize: '18px',
        cursor: 'pointer',
        color: '#718096'
    }
};

const LeadAcceptance = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedLead, setSelectedLead] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const fetchLeads = async () => {
        setLoading(true);
        setError(null);
        try {
            const authToken = localStorage.getItem("authToken");
            if (!authToken) throw new Error("No auth token found");
            const data = await getCateringOrders(authToken);
            
            if (Array.isArray(data)) {
                // Filter: display leads that have userId or customerId as some value (not null/undefined)
                // and leadStatus as "ASSIGNED"
                const filteredData = data.filter(item => {
                    const hasUserOrCustomer = (item.userId !== null && item.userId !== undefined) || 
                                             (item.customerId !== null && item.customerId !== undefined);
                    const isAssigned = item.leadStatus && item.leadStatus.toString().toUpperCase() === "ASSIGNED";
                    return hasUserOrCustomer && isAssigned;
                });
                setLeads(filteredData);
            } else {
                setLeads([]);
            }
        } catch (err) {
            console.error("Error fetching lead acceptance data:", err);
            setError("Failed to load lead acceptance data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeads();
    }, []);

    const handleViewDetails = (lead) => {
        setSelectedLead(lead);
        setShowViewModal(true);
    };

    // Filter leads by search term
    const filteredLeads = leads.filter(lead => {
        if (!searchTerm) return true;
        const term = searchTerm.toLowerCase();
        const leadId = (lead.id || '').toString();
        const userId = (lead.userId || lead.customerId || '').toString();
        const name = (lead.fullName || '').toLowerCase();
        const email = (lead.email || '').toLowerCase();
        const phone = (lead.phoneNumber || '').toLowerCase();
        const event = (lead.event || '').toLowerCase();
        const eventType = (lead.eventType || '').toLowerCase();
        const city = (lead.city || '').toLowerCase();

        return leadId.includes(term) ||
               userId.includes(term) ||
               name.includes(term) ||
               email.includes(term) ||
               phone.includes(term) ||
               event.includes(term) ||
               eventType.includes(term) ||
               city.includes(term);
    });

    // Calculate Statistics
    const totalLeads = leads.length;
    const totalVegPlates = leads.reduce((sum, l) => sum + (parseInt(l.vegPlates) || 0), 0);
    const totalNonVegPlates = leads.reduce((sum, l) => sum + (parseInt(l.nonVegPlates) || 0), 0);
    const totalBudget = leads.reduce((sum, l) => sum + (parseFloat(l.budget) || 0), 0);
    const totalPayment = leads.reduce((sum, l) => sum + (parseFloat(l.paymentAmount) || 0), 0);

    const formatCurrency = (val) => val ? `₹${parseFloat(val).toLocaleString('en-IN')}` : '₹0';

    return (
        <div style={styles.container}>
            {/* Header & Controls */}
            {/* <div style={styles.header}>
                <div style={styles.title}>
                    📋 Lead Acceptance
                    <span style={styles.titleBadge}>{totalLeads}</span>
                </div>
                <div style={styles.filterGroup}>
                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                        <input
                            type="text"
                            placeholder="Search Lead ID, User, Email, Event..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={styles.searchInput}
                        />
                    </div>
                    <button onClick={fetchLeads} style={styles.refreshBtn} disabled={loading}>
                        <Icons.Refresh /> {loading ? "Loading..." : "Refresh"}
                    </button>
                </div>
            </div> */}

            {/* Stats Summary Cards */}
            <div style={styles.statsContainer}>
                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconTotal }}>
                        <Icons.Total />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{totalLeads}</span>
                        <span style={styles.statLabel}>Assigned Leads</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconAccepted }}>
                        <Icons.Check />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{totalVegPlates + totalNonVegPlates}</span>
                        <span style={styles.statLabel}>Total Plates ({totalVegPlates}V / {totalNonVegPlates}NV)</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconPaid }}>
                        <Icons.Money />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{formatCurrency(totalBudget)}</span>
                        <span style={styles.statLabel}>Total Budget</span>
                    </div>
                </div>

                <div style={styles.statCard}>
                    <div style={{ ...styles.statIcon, ...styles.statIconPending }}>
                        <Icons.Paid />
                    </div>
                    <div style={styles.statContent}>
                        <span style={styles.statValue}>{formatCurrency(totalPayment)}</span>
                        <span style={styles.statLabel}>Payment Amount</span>
                    </div>
                </div>
            </div>

            {/* Error Message */}
            {error && (
                <div style={{ padding: '12px 16px', backgroundColor: '#fff5f5', border: '1px solid #feb2b2', borderRadius: '8px', color: '#c53030', marginBottom: '16px' }}>
                    {error}
                </div>
            )}

            {/* Main Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={styles.th}>Enquiry ID</th>
                            <th style={styles.th}>User / Customer ID</th>
                            <th style={styles.th}>Customer Info</th>
                            <th style={styles.th}>Event & Type</th>
                            <th style={styles.th}>Event Date & Time</th>
                            <th style={styles.th}>Plates (V / NV)</th>
                            <th style={styles.th}>Location</th>
                            <th style={styles.th}>Budget / Payment</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                                    <div style={{ color: '#718096', fontSize: '14px' }}>Loading assigned leads...</div>
                                </td>
                            </tr>
                        ) : filteredLeads.length > 0 ? (
                            filteredLeads.map((lead, index) => {
                                const activeUserId = lead.userId || lead.customerId || 'N/A';
                                return (
                                    <tr
                                        key={lead.id || index}
                                        style={{
                                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                            transition: 'background 0.15s ease'
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                    >
                                        <td style={styles.td}>
                                            <span style={styles.enquiryId}>#{lead.id}</span>
                                        </td>
                                        <td style={styles.td}>
                                            <span style={styles.userIdText}>
                                                {lead.userId ? `User #${lead.userId}` : lead.customerId ? `Cust #${lead.customerId}` : 'N/A'}
                                            </span>
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ fontWeight: '500', color: '#2d3748' }}>{lead.fullName || 'N/A'}</div>
                                            <div style={{ fontSize: '11px', color: '#718096' }}>{lead.email || ''}</div>
                                            {lead.phoneNumber && <div style={{ fontSize: '11px', color: '#718096' }}>📞 {lead.phoneNumber}</div>}
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ fontWeight: '600', color: '#2b6cb0' }}>{lead.eventType || lead.event || 'N/A'}</div>
                                            {lead.event && lead.eventType && <div style={{ fontSize: '11px', color: '#718096' }}>{lead.event}</div>}
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <Icons.Calendar /> {lead.eventDate || 'N/A'}
                                            </div>
                                            {lead.eventTime && <div style={{ fontSize: '11px', color: '#718096' }}>⏰ {lead.eventTime}</div>}
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ display: 'flex', gap: '6px' }}>
                                                <span style={{ color: '#276749', fontWeight: '600' }}>Veg: {lead.vegPlates || 0}</span>
                                                <span>|</span>
                                                <span style={{ color: '#9b2c2c', fontWeight: '600' }}>NV: {lead.nonVegPlates || 0}</span>
                                            </div>
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                <Icons.Location /> {lead.city || lead.fullAddress || 'N/A'}
                                            </div>
                                            {lead.state && <div style={{ fontSize: '11px', color: '#718096' }}>{lead.state}</div>}
                                        </td>
                                        <td style={styles.td}>
                                            <div style={{ fontWeight: '700', color: '#2d3748' }}>{formatCurrency(lead.budget)}</div>
                                            {lead.paymentAmount !== null && (
                                                <div style={{ fontSize: '11px', color: '#2b6cb0' }}>Paid: {formatCurrency(lead.paymentAmount)}</div>
                                            )}
                                        </td>
                                        <td style={{ ...styles.td, textAlign: 'center' }}>
                                            <span style={{ ...styles.badge, ...styles.badgeAssigned }}>
                                                <Icons.Check /> {lead.leadStatus || 'ASSIGNED'}
                                            </span>
                                        </td>
                                        <td style={{ ...styles.td, textAlign: 'center' }}>
                                            <button
                                                style={styles.viewBtn}
                                                onClick={() => handleViewDetails(lead)}
                                            >
                                                <Icons.Eye /> View
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="10" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>No assigned leads found</div>
                                        <div style={styles.emptyStateSubtext}>Leads with non-null User/Customer ID and ASSIGNED status will appear here</div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* View Details Modal */}
            {showViewModal && selectedLead && (
                <div style={styles.overlay} onClick={() => setShowViewModal(false)}>
                    <div style={styles.modalCard} onClick={(e) => e.stopPropagation()}>
                        <div style={styles.modalHeader}>
                            <h3 style={styles.modalTitle}>
                                📋 Lead Details - #{selectedLead.id}
                            </h3>
                            <button style={styles.closeBtn} onClick={() => setShowViewModal(false)}>✕</button>
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                            <div style={{ background: '#f7fafc', padding: '12px', borderRadius: '8px', border: '1px solid #edf2f7' }}>
                                <div style={{ fontSize: '12px', color: '#718096', fontWeight: '600', marginBottom: '4px' }}>CUSTOMER INFORMATION</div>
                                <div><strong>ID:</strong> {selectedLead.userId ? `User #${selectedLead.userId}` : selectedLead.customerId ? `Customer #${selectedLead.customerId}` : 'N/A'}</div>
                                <div><strong>Name:</strong> {selectedLead.fullName || 'N/A'}</div>
                                <div><strong>Email:</strong> {selectedLead.email || 'N/A'}</div>
                                <div><strong>Phone:</strong> {selectedLead.phoneNumber || 'N/A'}</div>
                            </div>

                            <div style={{ background: '#f7fafc', padding: '12px', borderRadius: '8px', border: '1px solid #edf2f7' }}>
                                <div style={{ fontSize: '12px', color: '#718096', fontWeight: '600', marginBottom: '4px' }}>EVENT DETAILS</div>
                                <div><strong>Event:</strong> {selectedLead.event} ({selectedLead.eventType})</div>
                                <div><strong>Date & Time:</strong> {selectedLead.eventDate} at {selectedLead.eventTime}</div>
                                <div><strong>Veg Plates:</strong> {selectedLead.vegPlates || 0}</div>
                                <div><strong>Non-Veg Plates:</strong> {selectedLead.nonVegPlates || 0}</div>
                            </div>
                        </div>

                        <div style={{ background: '#f7fafc', padding: '12px', borderRadius: '8px', border: '1px solid #edf2f7', marginBottom: '16px' }}>
                            <div style={{ fontSize: '12px', color: '#718096', fontWeight: '600', marginBottom: '4px' }}>LOCATION & FINANCIALS</div>
                            <div><strong>Address:</strong> {selectedLead.fullAddress || 'N/A'}, {selectedLead.city}, {selectedLead.state} {selectedLead.pincode}</div>
                            <div style={{ marginTop: '8px', display: 'flex', gap: '20px' }}>
                                <div><strong>Budget:</strong> <span style={{ color: 'rgb(230 109 51)', fontWeight: '700' }}>{formatCurrency(selectedLead.budget)}</span></div>
                                <div><strong>Payment Amount:</strong> <span style={{ color: '#2b6cb0', fontWeight: '700' }}>{formatCurrency(selectedLead.paymentAmount)}</span></div>
                                <div><strong>Status:</strong> <span style={{ color: '#155724', fontWeight: '700' }}>{selectedLead.leadStatus}</span></div>
                            </div>
                        </div>

                        {/* Selected Menu Items */}
                        {selectedLead.items && (
                            <div style={{ marginBottom: '16px' }}>
                                <div style={{ fontSize: '13px', color: 'rgb(230 109 51)', fontWeight: '600', marginBottom: '8px', borderBottom: '1px solid #edf2f7', paddingBottom: '4px' }}>
                                    🍽️ SELECTED MENU ITEMS
                                </div>
                                {typeof selectedLead.items === 'object' && !Array.isArray(selectedLead.items) ? (
                                    Object.entries(selectedLead.items).map(([category, itemsList]) => (
                                        <div key={category} style={{ marginBottom: '8px' }}>
                                            <span style={{ fontWeight: '600', fontSize: '12px', color: '#4a5568' }}>{category}: </span>
                                            <span style={{ fontSize: '13px' }}>{Array.isArray(itemsList) ? itemsList.join(', ') : itemsList}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ fontSize: '13px' }}>{Array.isArray(selectedLead.items) ? selectedLead.items.join(', ') : selectedLead.items.toString()}</div>
                                )}
                            </div>
                        )}

                        {/* Add-ons */}
                        {selectedLead.addOns && selectedLead.addOns.length > 0 && (
                            <div style={{ marginBottom: '16px' }}>
                                <div style={{ fontSize: '13px', color: 'rgb(230 109 51)', fontWeight: '600', marginBottom: '8px', borderBottom: '1px solid #edf2f7', paddingBottom: '4px' }}>
                                    ➕ ADD-ONS
                                </div>
                                <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                    {selectedLead.addOns.map((addon, idx) => (
                                        <span key={idx} style={{ background: '#edf2f7', padding: '4px 10px', borderRadius: '12px', fontSize: '12px' }}>
                                            {addon.addOnType || addon.name || 'AddOn'} (Qty: {addon.quantity || 1})
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {selectedLead.additionalRequests && (
                            <div style={{ fontSize: '12px', color: '#718096', fontStyle: 'italic' }}>
                                <strong>Note:</strong> {selectedLead.additionalRequests}
                            </div>
                        )}

                        <button
                            onClick={() => setShowViewModal(false)}
                            style={{
                                width: '100%',
                                padding: '10px',
                                background: 'rgb(230 109 51)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '14px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                marginTop: '16px'
                            }}
                        >
                            Close Details
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default LeadAcceptance;